import React from 'react';
import { useParams } from 'react-router-dom';

import HelpIcon from '../../../../assets/icons/payment-input-form/Help icon.svg';
import Checkbox from '../../../../shared/components/Checkbox';
import Tooltip from '../../../../shared/components/Tooltip';
import { PAYMENT_TEXTS, URLS } from '../../constants/payment.constants';

interface PaymentTermsProps {
    termsAccepted: boolean;
    setTermsAccepted: (accepted: boolean) => void;
    id?: string;
    className?: string;
}

const PaymentTerms: React.FC<PaymentTermsProps> = ({ termsAccepted, setTermsAccepted, id = "terms-checkbox", className = "" }) => {
    const { eventKey } = useParams();

    return (
        <div className={className}>
            <div className="flex items-center gap-2 mb-[12px]">
                <h4 className="font-noto font-semibold text-[12px] leading-[18px] text-[#030407] m-0">{PAYMENT_TEXTS.TERMS.HEADING}</h4>
                <Tooltip content={PAYMENT_TEXTS.TERMS.TOOLTIP} position="left">
                    <img
                        src={HelpIcon}
                        alt="Help"
                        className="w-4 h-4 cursor-pointer"
                    />
                </Tooltip>
            </div>
            <Checkbox
                checked={termsAccepted}
                onChange={setTermsAccepted}
                label={
                    <span className="font-noto font-[500] text-[12px] leading-[18px] text-[#475467] !cursor-default">
                        {PAYMENT_TEXTS.TERMS.AGREEMENT_PRE}
                        <a
                            href={URLS.TERMS_AND_CONDITIONS}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#475467] underline hover:text-gray-900 cursor-pointer font-noto font-[500] text-[12px] leading-[18px]"
                        >
                            {PAYMENT_TEXTS.TERMS.TERMS_LINK}
                        </a>
                        {PAYMENT_TEXTS.TERMS.AND}
                        <a
                            href={URLS.PRIVACY_POLICY}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#475467] underline hover:text-gray-900 cursor-pointer font-noto font-[500] text-[12px] leading-[18px]"
                        >
                            {PAYMENT_TEXTS.TERMS.PRIVACY_LINK}
                        </a>
                        {PAYMENT_TEXTS.TERMS.COMMA_AND}
                        <a
                            href={`/${eventKey}/event-privacy-policy`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#475467] underline hover:text-gray-900 cursor-pointer font-noto font-[500] text-[12px] leading-[18px]"
                        >
                            {PAYMENT_TEXTS.TERMS.EVENT_PRIVACY_LINK}
                        </a>
                    </span>
                }
                id={id}
            />
        </div>
    );
};

export default PaymentTerms;
